import { ISurveyIndicatorModel } from '../services/api/api-client';

export function useSurveyByType(surveyType: string, collection?: ISurveyIndicatorModel[]) {
  if (!collection || collection.length === 0) {
    return null;
  }
  const surveyItem = collection.find((x) => x.surveyTypeText === surveyType);
  return surveyItem || null;
}
